import { SyncServiceFactory } from "@prestosports/prestostats-core/Services";
import { performQueuedSync } from "../../state/app/actions";
import { INIT_GAME_DATA_COMPLETE } from "../../state/game/constants";

let init = false;
const listen = async (store) => {
	const { events } = store.getState();
	const { remoteEventChanged, currentEvent } = events;
	const { id: eventId, sportId } = currentEvent || {};
	const syncService = SyncServiceFactory.getInstance(sportId);

	if (eventId && syncService && !remoteEventChanged) {
		const { queuedSync, timeSynced } =
			(await syncService.getSyncByEventId(eventId)) || {};
		const shouldAttemptSync =
			queuedSync?.timestamp && queuedSync.timestamp !== timeSynced;

		if (shouldAttemptSync) {
			await performQueuedSync(eventId, store.dispatch);
		}
	}

	return setTimeout(() => listen(store), 5000);
};

const eventSyncMiddleware = (store) => (next) => async (action) => {
	if (!init && action?.type === INIT_GAME_DATA_COMPLETE) {
		init = true;
		listen(store);
	}
	return next(action);
};

export default eventSyncMiddleware;
